import {
  takeLatest, put, select,
} from 'redux-saga/effects'
import request from '@/helpers/axios'
import {
  GET_ANALYTICS_ALARMS_FILE,
} from '@/store/actions/analyticsAlarms'
import {
  ALARM_ANALYTICS_REPORT_TABLE_FILE_ENDPOINT,
} from '@/constants/apiRoutes'
import downloadFileFromBlob from '@/helpers/downloadFileFromBlob'
import createNotifications from '@/helpers/notification'
// TODO: fix actions name
import {
  successAlarmManagerFile,
  errorAlarmManagerFile,
} from '@/store/actions/analyticsAlarms/getFile'
import { getSelectedNode } from '@/store/selectors/appSettings'
import {
  getTableParameters,
  getCheckBoxOption,
} from '@/store/selectors/analyticsAlarms'

function* getAlarmManagerFileSaga({ payload }) {
  const toast = createNotifications()
  try {
    const node = yield select(getSelectedNode)
    const filterOptions = yield select(getCheckBoxOption)
    const filterOptionsArray = Object.keys(filterOptions)
      .reduce((accumulator, filter) => {
        if (filterOptions[filter]) {
          return [...accumulator, filter]
        }

        return accumulator
      }, [])

    const tableParameters = yield select(getTableParameters)

    const response = yield request({
      url: ALARM_ANALYTICS_REPORT_TABLE_FILE_ENDPOINT({
        params: {
          alertTypes: filterOptionsArray,
          excludeColumns: payload.allColumns.filter(x => !tableParameters.activeFields.includes(x)),
          parentId: node.id,
          pageNumber: tableParameters.page - 1,
          pageSize: tableParameters.perPage,
          name: tableParameters.requestQuery || '',
          sort: [`${tableParameters.sort.field}: ${tableParameters.sort.direction}`],
        },
        format: payload.value
      }),
      method: 'get',
      options: {
        responseType: 'blob',
      },
    })

    downloadFileFromBlob({
      blob: response.data,
      fileName: `${node.id || 'all'}_analytics-alarms.${payload.value}`,
    })
    yield put(successAlarmManagerFile())
  } catch (error) {
    yield put(errorAlarmManagerFile(error))
    toast({
      title: 'Ошибка операции!',
      description: 'Невозможно выгрузить отчет. Повторите попытку позже.',
      type: 'error',
    })
  }
}

export default function* root() {
  yield takeLatest(GET_ANALYTICS_ALARMS_FILE.REQUEST, getAlarmManagerFileSaga)
}
